import { createColumn, defaultColumns, inputTextField, numberSort, relationField } from '../_defaults/columns'
import { dateFormat } from '../../plugins/filters'

export const columns = [
  createColumn({
    label: 'Description',
    field: 'description',
    component: inputTextField({ type: 'textarea', req: false, max: 8192 })
  }),
  createColumn({
    label: 'Percent Discounted',
    field: 'percent',
    section: 'Discount',
    type: 'number',
    sort: numberSort,
    component: inputTextField({ req: false, type: 'number', money: true })
  }),
  createColumn({
    label: 'Exact Value Discounted',
    field: 'value',
    section: 'Discount',
    type: 'number',
    sort: numberSort,
    component: inputTextField({ req: false, type: 'number', money: true })
  }),
  createColumn({
    label: 'Code',
    field: 'code',
    section: 'Options',
    description: 'Leave blank if you want any and all to receive the discount.',
    component: inputTextField({ req: false })
  }),
  createColumn({
    label: 'Maximum Uses',
    field: 'maxNumberOfUsers',
    section: 'Options',
    type: 'number',
    sort: numberSort,
    description: 'Leave value of 0 for unlimited.',
    defaultValue: 0,
    component: inputTextField({ req: false, type: 'number' })
  }),
  createColumn({
    label: 'Start Date',
    field: 'startDate',
    section: 'Availability',
    type: 'date',
    description: 'Pick a date when this discount can be used.',
    displayValue: row => {
      return row.startDate ? dateFormat(row.startDate, 'MMM DD YYYY - h:mm a') : 'N/A'
    },
    component: {
      is: 'q-datetime',
      props: {
        type: 'datetime',
        format24h: false,
        format: 'MMM DD YYYY h:mm a',
        defaultValue: null,
        value: null,
        clearable: true,
        okLabel: 'Set Start',
        modal: true
        // dark: true
      },
      validation: {
        required: false
      }
    }
  }),
  createColumn({
    label: 'Expiration Date',
    field: 'expirationDate',
    section: 'Availability',
    type: 'date',
    description: 'Pick a date when this discount is no longer available.',
    displayValue: row => {
      return row.expirationDate ? dateFormat(row.expirationDate, 'MMM DD YYYY - h:mm a') : 'N/A'
    },
    component: {
      is: 'q-datetime',
      props: {
        type: 'datetime',
        format24h: false,
        format: 'MMM DD YYYY h:mm a',
        defaultValue: null,
        value: null,
        clearable: true,
        okLabel: 'Set Expiration',
        modal: true
        // dark: true
      },
      validation: {
        required: false
      }
    }
  }),
  createColumn({
    label: 'Event',
    field: 'event',
    ...relationField({
      type: 'one',
      namespace: 'event',
      filterIs: 'text-filter'
    })
  })
].concat(defaultColumns)
